import { markRaw, reactive } from 'vue';

export const modalStack = reactive([]);

let modalIdCounter = 0;

function createModalHandle() {
  const listeners = {};

  return {
    _vm: null,
    $on(event, callback) {
      (listeners[event] || (listeners[event] = [])).push(callback);

      return this;
    },
    $emit(event, ...args) {
      (listeners[event] || []).forEach(callback => callback(...args));

      return this;
    },
    close() {
      if (this._vm) {
        this._vm.close();
      }
    },
  };
}

export const fullscreenModal = {
  get instances() {
    return modalStack;
  },

  open(parentVm, component, properties = {}, options = {}) {
    const handle = createModalHandle();

    modalStack.push(markRaw({
      id: ++modalIdCounter,
      component,
      properties,
      options,
      handle,
    }));

    return handle;
  },

  closed(handle) {
    const index = modalStack.findIndex(entry => entry.handle === handle);
    if (index === -1) {
      return;
    }

    modalStack.splice(index, 1);
    handle.$emit('closed');

    if (modalStack.length === 0) {
      document.body.classList.remove('overflow-hidden');
    }
  },

  closeAll() {
    [ ...modalStack ].forEach(entry => entry.handle.close());
  },
};

/* eslint-disable-next-line local-rules/custom-naming-pattern */
const FullscreenModal = {
  install(app) {
    app.config.globalProperties.$fullscreenModal = fullscreenModal;

    // Keydown in the capture phase: at that point a popover / dropdown opened
    // inside the modal (UI kit layers carry data-dismissable-layer) is still
    // open, and Escape should only close that layer, not the modal.
    document.addEventListener('keydown', event => {
      if (event.key !== 'Escape' || document.querySelector('[data-dismissable-layer]')) {
        return;
      }

      const count = modalStack.length;
      if (count === 0) {
        return;
      }

      modalStack[count - 1].handle.close();
    }, true);
  },
};

export default FullscreenModal;
